<div class="container py-4">
  <!-- Introduction Section -->
  <section class="mb-5">
    <div class="text-center mb-4">
      <h2 class="fw-bold">Introduction</h2>
    </div>
    <div class="px-3">
      <p>
        <strong>Chhatrapati Sambhaji Raje Global School & Jr. College</strong> is a CBSE English Medium school
        established in 2017 by Jai Bharti Bahuuddeshiya Sevabhavi Pratishthan, Ghatnandur.
      </p>
      <p>
        CSRGS conducts classes from 1st to 10th standard. The students are encouraged to think globally through
        quality education, with a strong focus on academics, sports, and cultural development. We are supported by a
        committed and responsible staff. The school building is an architectural marvel, designed for student comfort.
      </p>
    </div>
  </section>

  <!-- Image Section -->
  <section class="text-center mb-5">
    <figure>
      <img src="https://www.csrgs.org/assets/images/aimsObjective.jpg" class="img-fluid rounded shadow-sm"
        alt="Aims and Objectives" />
      <figcaption class="mt-2 text-muted">Our Vision and Mission in Action</figcaption>
    </figure>
  </section>

  <!-- Aims and Objectives Section -->
  <section>
    <div class="text-center mb-4">
      <h2 class="fw-bold">Aims and Objectives</h2>
      <p class="text-muted">Our mission is to foster growth and responsibility in every student.</p>
    </div>
    <ul class="list-group list-group-flush px-3">
      <li class="list-group-item">
        Develop good health habits and build essential personal skills.
      </li>
      <li class="list-group-item">
        Encourage desirable social attitudes and group cooperation.
      </li>
      <li class="list-group-item">
        Promote respect for the rights and privileges of others.
      </li>
      <li class="list-group-item">
        Foster a cheerful attitude and appreciation for societal values.
      </li>
      <li class="list-group-item">
        Instill a sense of social responsibility and lifelong service.
      </li>
      <li class="list-group-item">
        Educate students on valuing and using freedom wisely.
      </li>
      <li class="list-group-item">
        Enhance self-awareness, confidence, and contributions to nation-building.
      </li>
      <li class="list-group-item">
        Encourage problem-solving in academic and real-life contexts.
      </li>
      <li class="list-group-item">
        Motivate excellence with empathy for others’ needs.
      </li>
      <li class="list-group-item">
        Develop effective communication among staff, students, and parents.
      </li>
    </ul>
  </section>
</div>